import { useTranslation } from 'react-i18next';
import { FaRegTrashAlt } from 'react-icons/fa';
import { FaArrowDown, FaArrowUp } from 'react-icons/fa6';

import { Button } from '@client/toolkit';

export interface EconomyRowActionsProps {
  /** i18n prefix of the owning table, e.g. `settings.groupAccounts`. */
  section: string;
  /** Interpolated into the labels so each row's controls are distinguishable. */
  row: string;
  isFirst: boolean;
  isLast: boolean;
  onMoveUp: () => void;
  onMoveDown: () => void;
  onRemove: () => void;
}

/** Boxed gold icon buttons, as on the Brukere and Underprodukter tables. */
const ACTION_PROPS = {
  type: 'button',
  size: 'xs',
  color: 'primary-invert',
  className: 'size-9',
} as const;

/** Reorder and remove for one table row, shown in the trailing Handlinger column. */
export function EconomyRowActions({
  section,
  row,
  isFirst,
  isLast,
  onMoveUp,
  onMoveDown,
  onRemove,
}: EconomyRowActionsProps) {
  const { t } = useTranslation('economy');

  const label = (action: string) => t(`${section}.rowActions.${action}`, { row });

  return (
    <div className="flex items-center justify-end gap-2">
      <Button {...ACTION_PROPS} disabled={isFirst} title={label('moveUp')} aria-label={label('moveUp')} onClick={onMoveUp}>
        <FaArrowUp />
      </Button>
      <Button
        {...ACTION_PROPS}
        disabled={isLast}
        title={label('moveDown')}
        aria-label={label('moveDown')}
        onClick={onMoveDown}
      >
        <FaArrowDown />
      </Button>
      <Button {...ACTION_PROPS} title={label('remove')} aria-label={label('remove')} onClick={onRemove}>
        <FaRegTrashAlt />
      </Button>
    </div>
  );
}

export default EconomyRowActions;
